// extracted by mini-css-extract-plugin
module.exports = {"root":"WizardStepMenu-module__root__21Q5k"};